<template>
    <div class="accordion body-container" @click="expanded = !expanded">
        <h2 class="title">
            {{ title }}
        </h2>
        <div class="arrow-block border" :style="{ background: 'white' }">
            <i class="icon-chevron-down rotated" :class="expanded ? 'down' : 'right'"></i>
        </div>
    </div>
    <Transition name="scale-up-to-up">
        <div
            v-show="expanded"
            class="content info"
            :class="{'ec_border': props.bordered}"
            :style="contentStyle"
        >
            <slot></slot>
            {{ info }}
        </div>
    </Transition>
</template>

<script setup>
import {ref, computed, onBeforeMount} from "vue";

const expanded = ref(false);
const maxHeight = ref(0);

const flags = ref({
    viber: false,
    telegram: false,
    whatsapp: false,
});

const props = defineProps({
    title: String,
    info: String,
    isOpen: {
        type: Boolean,
        default: false,
    },
    bordered: {
        type: Boolean,
        default: true
    }
});

const contentStyle = computed(() => {
    if (expanded.value) {
        maxHeight.value = "fit-content";
    } else {
        maxHeight.value = 0;
    }
    return {"max-height": maxHeight};
});

onBeforeMount(() => {
    expanded.value = props.isOpen;
});
</script>

<style scoped lang="scss">
.body-container {
    padding: 20px 15px;
}

.accordion {
    position: relative;
    margin-top: 30px;
    display: flex;
    gap: 25px;
    box-sizing: border-box;
    border-radius: 11px;
    background-color: #f4f3fc;
    cursor: pointer;
}

.title {
    font-size: 22px;
    text-transform: uppercase;
}

.accordion h4 {
    text-transform: none;
    line-height: 1.5;
}

.accordion p {
    margin-bottom: 0;
    margin-top: 0.5rem;
}

.accordion header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.content {
    height: fit-content;
    margin-top: 20px;
    transition: height 0.2s ease-out;
}

.arrow-block {
    min-width: 27px;
    height: 27px;
    margin-top: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 7px;
    background-color: #fff;
}

.rotated {
    transition: all 0.5s ease-in-out;

    &.right {
        transform: rotate(-90deg);
        margin-left: 3px;
        color: var(--general-color);
    }

    &.down {
        margin-top: 5px;
        transform: rotate(0);
        color: var(--general-color);
    }
}

.border {
    border: 1px solid var(--general-color);
}

.fab {
    color: grey;

    &:hover {
        color: var(--general-color);
    }
}

@media screen and (max-width: 740px) {
    .accordion {
        justify-content: space-between;
    }
}

//Animation
.appear-enter-active,
.appear-leave-active {
    // transition: all 0.5s ease;
    height: auto;
}

.appear-enter,
.appear-enter-from,
.appear-leave-to {
    // transition: all 0.5s ease;
    height: 0;
}
</style>
